import React from 'react';
import {connect} from 'react-redux';
import {changeInput, changeInput2} from "../lib/actions";
import {CHARM, MAX_CHARM_LETTERS_PER_LINE,} from "../../constants";

class InputHeader extends React.Component {
    getDescription(orientation) {
        switch (orientation) {
            case CHARM.ONELINE:
                return 'Up to six characters joined in a line.';
            case CHARM.TWOLINES:
                return 'Up to two lines with six characters each.';
            case CHARM.VERTICAL:
                return 'Up to six characters in a vertical line.';
        }
    }

    render() {
        return (
            <div className="customizer__header">
                <h4>
                    {this.props.charmOrientation.description} Text
                </h4>
                <p>{this.getDescription(this.props.charmOrientation)}</p>
            </div>
        );
    }
}

class Input extends React.Component {
    onLineOneChange(value) {
        if (this.isInvalidInput(value)) return;

        this.props.onLineOneChange(value.toUpperCase());
    }

    onLineTwoChange(value) {
        if (this.isInvalidInput(value)) return;

        this.props.onLineTwoChange(value.toUpperCase());
    }

    isInvalidInput(value) {
        if (/[^a-zA-Z0-9&]/.test(value)) {
            return true;
        }

        if (value.length && value.length > MAX_CHARM_LETTERS_PER_LINE) {
            return true;
        }

        return false;
    }

    render() {
        let counterClassName = 'customizer-input__count';

        if (!this.props.input || this.props.input.length === 0) {
            counterClassName += ' customizer-input__count-error';
        }

        if (this.props.orientation === CHARM.TWOLINES && (!this.props.input2 || this.props.input2.length === 0)) {
            counterClassName += ' customizer-input__count-error';
        }

        return (
            <>
                <InputHeader charmOrientation={this.props.orientation}/>

                <div className='customizer-input'>
                    <div className='customizer-input__line'>
                        {this.props.orientation === CHARM.TWOLINES &&
                            <label className='customizer-input__label' htmlFor='customizer-input-one'>Line one</label>
                        }
                        <input className='customizer-input__field' id='customizer-input-one' type='text' value={this.props.input} onChange={(e) => this.onLineOneChange(e.target.value)}/>
                        <div className={counterClassName}>{this.props.input ? this.props.input.length : 0}/{MAX_CHARM_LETTERS_PER_LINE}</div>
                    </div>

                    {this.props.orientation === CHARM.TWOLINES &&
                        <>
                            <div className='customizer-input__line'>
                                <label className='customizer-input__label' htmlFor='customizer-input-two'>Line two</label>
                                <input className='customizer-input__field' id='customizer-input-two' type='text' value={this.props.input2} onChange={(e) => this.onLineTwoChange(e.target.value)}/>
                                <div
                                    className={counterClassName}>{this.props.input2 ? this.props.input2.length : 0}/{MAX_CHARM_LETTERS_PER_LINE}</div>
                            </div>
                        </>
                    }
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        input: state.input,
        input2: state.input2,
        orientation: state.charmOrientation,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLineOneChange: (input) => {
            dispatch(changeInput(input));
        },
        onLineTwoChange: (input2) => {
            dispatch(changeInput2(input2));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Input);
